<template>
  <div>
    <v-container style="max-width: 1170px">
      <v-row>
        <h2 class="mb-5">
          {{ toLatin($store.state.user.user.name) }}
          {{ toLatin($store.state.user.user.lastname) }} /
          {{ $t("password_change") }}
        </h2>
      </v-row>
    </v-container>
    <v-container style="max-width: 500px">
      <v-card-text>
        <v-form v-model="valid">
          <text-field
            v-model="newPass"
            :label="$t('enter_new_password')"
            name="newPassword"
            append-icon="mdi-lock"
            :rules="[rules.required, rules.password]"
            type="password"
            :disabled="loading.changePassword"
          />
          <text-field
            v-model="newPassCheck"
            :label="$t('confirm_new_pass')"
            name="newPasswordCheck"
            :rules="[rules.required, rules.repeatPassword(newPass, newPassCheck)]"
            append-icon="mdi-lock"
            type="password"
            :disabled="loading.changePassword"
          />
          <v-alert dense outlined type="error" v-if="failedCheck">
            {{ $t("entered_passwords_do_not_match") }}
          </v-alert>
          <text-field
            v-model="currPass"
            :label="$t('enter_your_password')"
            name="currPassword"
            append-icon="mdi-lock"
            :rules="[rules.required, rules.password]"
            type="password"
            :disabled="loading.changePassword"
          />

          <v-alert dense outlined type="error" v-if="failedPass">
            {{ $t("incorrect_password") }}
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <primary-button
          @click="update"
          :loading="loading.changePassword"
          :disabled="!valid"
          :dark="valid"
        >
          {{ $t("confirm_pass_change") }}
        </primary-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import userService from "@/services/user";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasValidation from "@/mixins/hasValidation";

export default {
  mixins: [hasSnackbar, hasValidation],
  data() {
    return {
      failedPass: false,
      failedCheck: false,
      newPass: null,
      newPassCheck: null,
      currPass: null,
      loading: {
        changePassword: false,
      },
    };
  },
  methods: {
    async update() {
      if (this.loading.changePassword) {
        console.warn(
          "Change password operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.failedCheck = false;
      this.failedPass = false;

      if (this.newPass != this.newPassCheck) {
        this.failedCheck = true;
        return;
      }

      this.loading.changePassword = true;

      try {
        await userService.changePassword(
          this.$store.state.user.user.id,
          this.currPass,
          this.newPass
        );
        this.showSuccessSnackbar(this.$t("password_changed_successfully"));
        this.$router.push({ name: "profil" });
      } catch (error) {
        console.error("Error changing password:", error);
        this.failedPass = true;
        this.showErrorSnackbar(error, this.$t("error_changing_password"));
      } finally {
        this.loading.changePassword = false;
      }
    },
  },
};
</script>
